/*
 *
 * Absence actions
 *
 */

import {
  // list
  LOAD_ABSENCES,
  LOAD_ABSENCES_SUCCESS,
  LOAD_ABSENCES_ERROR,
  CHANGE_ABSENCES,
  CHANGE_ABSENCES_SUCCESS,
  CHANGE_ABSENCES_ERROR,
  // single
  CHANGE_ABSENCE,
  CHANGE_ABSENCE_SUCCESS,
  CHANGE_ABSENCE_ERROR,
  DELETE_ABSENCE,
  DELETE_ABSENCE_SUCCESS,
  DELETE_ABSENCE_ERROR,
  FLUSH_STATE_ABSENCE,
} from './constants';

// Clearing the state
export function flushStateAbsence() {
  return {
    type: FLUSH_STATE_ABSENCE,
  };
}

// Load All
export function loadAbsences() {
  return {
    type: LOAD_ABSENCES
  };
}
export function loadAbsencesSuccess(itemsList, firstElem) {
  return {
    type: LOAD_ABSENCES_SUCCESS,
    itemsList,
    firstElem,
  };
}
export function loadAbsencesError(error) {
  return {
    type: LOAD_ABSENCES_ERROR,
    error,
  };
}

// Change List
export function changeAbsences(list) {
  return {
    type: CHANGE_ABSENCES,
    list,
  };
}
export function changeAbsencesSuccess(updatedList) {
  return {
    type: CHANGE_ABSENCES_SUCCESS,
    updatedList,
  };
}
export function changeAbsencesError(listError) {
  return {
    type: CHANGE_ABSENCES_ERROR,
    listError,
  };
}

// Change One
export function changeAbsence(absenceData) {
  return {
    type: CHANGE_ABSENCE,
    absenceData,
  };
}
export function changeAbsenceSuccess(absenceData) {
  return {
    type: CHANGE_ABSENCE_SUCCESS,
    absenceData,
  };
}
export function changeAbsenceError(dataError) {
  return {
    type: CHANGE_ABSENCE_ERROR,
    dataError,
  };
}

// Delete
export function deleteAbsence(id) {
  return {
    type: DELETE_ABSENCE,
    id,
  };
}
export function deleteAbsenceSuccess() {
  return {
    type: DELETE_ABSENCE_SUCCESS,
  };
}
export function deleteAbsenceError(deleteError) {
  return {
    type: DELETE_ABSENCE_ERROR,
    deleteError,
  };
}


